import React from 'react';
import { defaultStyles, FileIcon } from 'react-file-icon';
import { Document, Page, pdfjs } from 'react-pdf';
import classnames from 'classnames';

import FileUtil from '@utils/FileUtil';

import { IDisplayEditAttachment } from '../Attachment/AttachmentsEditModal';

import DownloadButton from './DownloadAttachment';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './style.scss';

interface IPdfViewerProps {
  attachment: IDisplayEditAttachment;
}

interface IPdfViewerState {
  showFallbackComponent: boolean;
  numPages: number;
}

class PdfViewer extends React.Component<IPdfViewerProps, IPdfViewerState> {
  constructor(props: IPdfViewerProps) {
    super(props);
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

    this.state = {
      showFallbackComponent: false,
      numPages: null,
    };
  }

  onError = () => {
    this.setState({
      showFallbackComponent: true,
    });
  };

  onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    this.setState({ numPages });
  };

  render() {
    const { attachment } = this.props;
    const { fileURL } = attachment;
    const fileExtension: string = FileUtil.getFileExtension(fileURL);

    if (this.state.showFallbackComponent) {
      const fallbackMsg =
        'Something went wrong while loading attachment. Please download the attachment from the link below.';

      return (
        <>
          <div className={classnames('document-view-fallback attachments-tile__saved-thumb')}>
            <FileIcon extension={fileExtension} {...defaultStyles[fileExtension]} />
          </div>
          <DownloadButton attachment={attachment} errMsg={fallbackMsg} />
        </>
      );
    }

    const { numPages } = this.state;

    const renderer = (
      <Document file={fileURL} onLoadSuccess={this.onDocumentLoadSuccess} onLoadError={this.onError}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
    );

    return <div className={'pdf-viewer'}>{renderer}</div>;
  }
}

export default PdfViewer;
